



















import { General } from "@/utils/constants";

export default {
  name: "GAInfo",
  data() {
    return {
      General,
      isAcceptGA: Boolean(localStorage.getItem("LGPD:accept_GA"))
    };
  },

  methods: {
    accept() {
      this.isAcceptGA = true;
      localStorage.setItem("LGPD:accept_GA", "true");
    }
  }
};
